<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" max-width="600" scrollable persistent>
			<v-card>
				<v-card-title class="text-h6">Ubah Alamat Pelanggan</v-card-title>
				<v-card-text>
					<v-form ref="formAddress" role="form">
						<v-row>
							<v-col cols="12" class="pb-0">
								<v-autocomplete outlined dense v-model="provinsi" :rules="provinceRules" @focus="() => responseError.province_id=''" :error-messages="responseError.province_id" :items="provinces" label="Provinsi" item-text="province" item-value="province_id" @change="getCity" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
							</v-col>
							<v-col cols="12" class="pb-0">
								<v-autocomplete outlined dense v-model="kota" :rules="cityRules" @focus="() => responseError.city_id=''" :error-messages="responseError.city_id" :items="cities" label="Kota/Kabupaten" @change="getSubdistrict" :item-text="item => item.type + ' ' + item.city_name" item-value="city_id" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
							</v-col>
							<v-col cols="12" class="pb-0">
								<v-autocomplete outlined dense @change="cekMaps" :rules="subdistrictRules" @focus="() => responseError.subdistrict_id=''" :error-messages="responseError.subdistrict_id" v-model="kecamatan" :items="subdistricts" item-text="subdistrict_name" item-value="subdistrict_id" label="Kecamatan" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
							</v-col>
							<v-col cols="12" class="pb-0">
								<v-textarea outlined dense @change="cekMaps" :rules="addressRules" @focus="() => responseError.address=''" :error-messages="responseError.address" v-model="address" label="Alamat Lengkap" no-resize height="190"></v-textarea>
							</v-col>
							<v-col cols="6" class="pb-0">
								<v-text-field outlined dense hide-details label="Latitude" :value="location.lat" @input="updateLat"></v-text-field>
							</v-col>
							<v-col cols="6" class="pb-0">
								<v-text-field outlined dense hide-details label="Longitude" :value="location.lng" @input="updateLng"></v-text-field>
							</v-col>
							<v-col cols="12" class="pb-0" v-if="true">
								<v-card elevation="0" width="100%" height="190">
									<GmapMap :center="{ lat: location.lat, lng: location.lng}" :zoom="16" :options="mapOptions" map-type-id="roadmap" style="width: 100%; height: 100%" >
										<GmapMarker ref="myMarker" :position="{ lat: location.lat, lng: location.lng}" :draggable="true" @dragend="updateCoordinates"></GmapMarker>
									</GmapMap>
								</v-card>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="batal">Batal</v-btn>
					<v-btn color="primary" depressed class="text-capitalize" @click="simpan">Simpan</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import {mapActions,  mapState, mapMutations} from 'vuex'
export default {
	data () {
		return {
			dialog: false,
			params: [],
			provinsi : '',
			kota : '',
			kecamatan : '',
			address: '',
			provinceRules: [
			value => !!value || 'Provinsi tidak boleh kosong',
			],
			cityRules: [
			value => !!value || 'Kota tidak boleh kosong',
			],
			subdistrictRules: [
			value => !!value || 'Kecamatan tidak boleh kosong',
			],
			addressRules: [
			value => !!value || 'Alamat Lengkap tidak boleh kosong',
			],
			mapOptions:{
				zoomControl: true,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false,
				disableDefaultUi: true
			},
			provinces: [],
			cities: [],
			subdistricts: [],
		}
	},
	computed: {
		...mapState('customerList', ['responseError']),
		...mapState('maps', ['location']),
	},
	methods: {
		...mapActions('customerList', ['getOptionProvince', 'getOptionCity', 'getOptionSubdistrict']),
		...mapActions('maps', ['getMaps', 'getGeolocation']),
		...mapMutations('maps', ['setLocation']),

		updateLat(val) {
			this.setLocation({
				lat: parseFloat(val),
				lng: parseFloat(this.location.lng)
			})
		},
		updateLng(val) {
			this.setLocation({
				lat: parseFloat(this.location.lat),
				lng: parseFloat(val)
			})
		},
		updateCoordinates(location){
			this.setLocation({
				lat: location.latLng.lat(),
				lng: location.latLng.lng()
			})
		},
		cekMaps(){
			let district = this.subdistricts.find(el => el.subdistrict_id == this.kecamatan)
			this.getMaps((this.address ? this.address + ', ' : '') + district.subdistrict_name + ', ' + district.city_name + ', ' + district.province)
		},
		async getCity() {
			this.kota = await '';
			this.kecamatan = await '';
			this.cities = await this.getOptionCity(this.provinsi)
		},
		async getSubdistrict() {
			this.kecamatan = await '';
			this.subdistricts = await this.getOptionSubdistrict(this.kota)
		},
		async showModal(data) {
			this.detailCustomer = data;
			this.provinces = await this.getOptionProvince()
			if (this.detailCustomer.customer_province_id && this.detailCustomer.customer_province_id > 0)
				this.cities = await this.getOptionCity(this.detailCustomer.customer_province_id)
			if (this.detailCustomer.customer_city_id && this.detailCustomer.customer_city_id > 0)
				this.subdistricts = await this.getOptionSubdistrict(this.detailCustomer.customer_city_id)
			this.provinsi = await this.detailCustomer.customer_province_id
			this.kota = await this.detailCustomer.customer_city_id
			this.kecamatan = await this.detailCustomer.customer_subdistrict_id
			this.address = await this.detailCustomer.customer_address
			this.dialog = await true
		},
		hideModal() {
			this.dialog = false
		},
		batal() {
			this.hideModal()
		},
		simpan() {
			if (this.$refs.formAddress.validate()) {
				let subdistrict = this.subdistricts.find( el => el.subdistrict_id == this.kecamatan )
				let params = {
					id: this.detailCustomer.customer_id,
					network_id: this.detailCustomer.customer_network_id,
					network_mid: this.detailCustomer.customer_network_mid,
					network_code: this.detailCustomer.customer_network_code,
					name: this.detailCustomer.customer_name,
					email: this.detailCustomer.customer_email,
					mobilephone: this.detailCustomer.customer_mobilephone,
					mobilephone2: this.detailCustomer.customer_mobilephone2,
					province_id: subdistrict.province_id,
					province_name: subdistrict.province,
					city_id: subdistrict.city_id,
					city_name: subdistrict.city_name,
					subdistrict_id: subdistrict.subdistrict_id,
					subdistrict_name: subdistrict.subdistrict_name,
					address: this.address,
					latitude: this.location.lat,
					longitude: this.location.lng,
					level: this.detailCustomer.customer_level,
					trx_method: this.detailCustomer.customer_trx_method,
					trx_ecommerce: this.detailCustomer.customer_trx_ecommerce
				}
				this.$emit('action', params)
			}
		},
	},
}
</script>
